import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../api.service';
import * as FileSaver from 'file-saver';
import { IncidentsAsigned } from '../shared/models/IncidentsAsigned';
import { UsersSupportDoc } from '../shared/models/UsersSupportDoc';
import { UsersSupportWrapperVO } from '../shared/models/UsersSupportWrapperVO';

@Component({
  selector: 'app-tovpil-incidents-check-hours',
  templateUrl: './tovpil-incidents-check-hours.component.html',
  providers: [MessageService, ConfirmationService],
  styleUrls: ['./tovpil-incidents-check-hours.component.scss']
})
export class TovpilIncidentsCheckHoursComponent implements OnInit {
  usersSupportWrapper:UsersSupportWrapperVO;
  lstIncidentsAssigned?: IncidentsAsigned[]=[];
  lstUsersSupportDoc:UsersSupportDoc[]=[]; 
  selectedUsersSupport?: UsersSupportDoc;
  assignedTo?:string;
  date1?: Date;
  date2?: Date;
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router

  ) { }

  ngOnInit(): void {
    this.apiService.getAllUsersSupport().then(
      data => {
        this.usersSupportWrapper=data;
        if(this.usersSupportWrapper.status=='OK'){
           this.lstUsersSupportDoc=this.usersSupportWrapper.lstUsersSupport;
        }
      });
  }
  search(){
    this.assignedTo=this.selectedUsersSupport.userId;
    this.apiService.listIncidentsAssignedTo(this.datepipe.transform(this.date1, 'yyyyMMdd'),this.datepipe.transform(this.date2, 'yyyyMMdd'),this.assignedTo 
  ).then(
    incidents => {
      this.lstIncidentsAssigned = incidents;
      
    })
  }
  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.lstIncidentsAssigned);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "incidents-list");
    });
}
saveAsExcelFile(buffer: any, fileName: string): void {
  let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = '.xlsx';
  const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}
}
